var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d8fa474cbaf4d2a5e7ee13f86bc660a1f6ddaf2e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lifeworkcalendar@reclaimai"]={id:"d8fa474cbaf4d2a5e7ee13f86bc660a1f6ddaf2e"};
      